import React, { useEffect, useState } from 'react';
import { Modal, Box, Button, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import "../FavoritesListSearch/FavoriteListSearch.css";
import { APIUrlThree, APIUrlToken, GetUserId } from '../../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loader from '../../Loader/Loader';

const DataEnrichFavModal = ({ open, handleClose, setOpen, selectedOuterRows, message, setSelectedOuterRows, enrichData }) => {

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const userId = GetUserId()
    const [loading, setLoading] = useState()
    const [selectedList, setSelectedList] = useState([]);
    const [selectedListPeople, setSelectedListPeople] = useState([]);

    const [selectedValue, setSelectedValue] = useState("");
    const [favoriteModal, setFavoriteModal] = useState(false);

    const [addFavouriteModal, setAddFavouriteModal] = useState(false);
    const [listName, setListName] = useState("");


    const handleOpenFavoriteModal = () => {
        if (!selectedValue) {
            toast.error("Please Select Existing Name");
            return;
        }
        setFavoriteModal(true);
        setOpen(false)

    }

    const handleCloseFavoriteModal = () => {
        setFavoriteModal(false);
        setListName("");
    }

    const handleOpenAddFavouriteModal = () => {
        setAddFavouriteModal(true);
        setOpen(false)
        setSelectedValue("")

    }
    const handleCloseAddFavouriteModal = () => {
        setListName("");
        setAddFavouriteModal(false);
    }





    const getFavListorg = () => {
        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/get_favourite_list_org?user_id=${userId}`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    if (Array.isArray(e.data)) {
                        setSelectedList(e.data);
                    } else if (Array.isArray(e.data?.data)) {
                        setSelectedList(e.data.data);
                    } else {
                        console.error("Unexpected API response format:", e.data);
                        setSelectedList([]);
                    }
                    toast.success(e?.data?.message);
                }
            })
            .catch((err) => {
                console.error("Error fetching favorite lists", err);
                setLoading(false);
            });
    };

    const getFavListPeople = () => {
        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/get_favourite_list_people?user_id=${userId}`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    if (Array.isArray(e.data)) {
                        setSelectedListPeople(e.data);
                    } else if (Array.isArray(e.data?.data)) {
                        setSelectedListPeople(e.data.data);
                    } else {
                        console.error("Unexpected API response format:", e.data);
                        setSelectedListPeople([]);
                    }
                    toast.success(e?.data?.message);
                }
            })
            .catch((err) => {
                console.error("Error fetching favorite lists", err);
                setLoading(false);
            });
    };


    useEffect(() => {
        getFavListorg();
        getFavListPeople();
    }, [open])




    const saveOrgFavList = () => {
        if (!listName?.trim()) {
            toast.error("Please Type List Name");
            return;
        }
        setLoading(true);
        const data = {
            user_id: userId,
            name: listName,
            isPrivate: true,
            type: "organization",

        };
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/save_favourite_list_org`,
            data: data,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    handleMultipleFavorites(e.data.data.id)
                    toast.success(e?.data?.message)
                    setListName("");
                    setAddFavouriteModal(false);
                    setFavoriteModal(false)
                }

            })
            .catch((err) => {
                console.error('Error enriching prospect', err);
                setLoading(false);
            });
    };

    const savePeopleFavList = () => {
        if (!listName?.trim()) {
            toast.error("Please Type List Name");
            return;
        }
        setLoading(true);
        const data = {
            user_id: userId,
            name: listName,
            isPrivate: true,
            type: "people",

        };
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/save_favourite_list_people`,
            data: data,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    handleMultipleFavorites(e.data.data.id)
                    toast.success(e?.data?.message)
                    setListName("");
                    setAddFavouriteModal(false);
                    setFavoriteModal(false)
                }

            })
            .catch((err) => {
                console.error('Error enriching prospect', err);
                setLoading(false);
            });
    };



    const handleMultipleFavorites = async (list) => {
        if (!selectedOuterRows || selectedOuterRows.length === 0) return;

        setLoading(true);

        const selectedList = list || selectedValue;
        const selectedListPeople = list || selectedValue;

        try {
            await Promise.all(
                selectedOuterRows.map((item) => handleFavorite(item, selectedList, selectedListPeople))
            );
            toast.success("All selected items added to favorites");
            setListName("");
            setAddFavouriteModal(false);
            setFavoriteModal(false)
            setSelectedOuterRows([])
            enrichData()
        } catch (error) {
            setOpen(false)
            setListName("");
            setAddFavouriteModal(false);
            setFavoriteModal(false)
            setSelectedOuterRows([])
        } finally {
            setLoading(false);
            setListName("");
            setAddFavouriteModal(false);
            setFavoriteModal(false)
            setSelectedOuterRows([])
            setOpen(false)
        }
    };

    const handleFavorite = async (item, value) => {

        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/${item?.category === "prospects"
                ? "favorite_enriched_prospects"
                : "favorite_enriched_organizations"
                }?user_id=${Number(GetUserId())}&filename=${item.filename}&${item?.category === "prospects" ? "listid" : "listId"}=${value}`,
        };

        try {
            await axios(option);

        } catch (error) {
            toast.error(error?.response?.data?.error)
            throw error;
        }
    };

    return (
        <>
            {loading ? <Loader /> : null}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style}>
                        <h3 className="type-of-list-fav">
                            Add To Favorites List
                            <ClearIcon onClick={() => { setOpen(false) }} style={{ cursor: "pointer" }} />
                        </h3>
                        <div className="type-of-list-fav-body">
                            <div className="input-list-fav-create">
                                <label>Existing List Name</label>

                                <Select
                                    className="input-list-fav-create-select"
                                    value={selectedValue}
                                    onChange={(e) => setSelectedValue(e.target.value)}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select a list</MenuItem>
                                    {selectedOuterRows.some(row => row.category === "organization") &&
                                        selectedList.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))
                                    }

                                    {selectedOuterRows.some(row => row.category === "prospects") &&
                                        selectedListPeople.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))
                                    }



                                </Select>



                            </div>
                            <div className='create-new-list-inner-modal' onClick={handleOpenAddFavouriteModal}>
                                <p> <AddIcon /> Create New List </p>
                            </div>

                            <div className="de_hr">
                                <div className="de_btn_cont">
                                    <Button className="de_cancel" onClick={() => { setOpen(false) }} >
                                        Cancel
                                    </Button>
                                    <Button className="de_next"
                                        // onClick={handleFavAddRecords}
                                        onClick={handleOpenFavoriteModal}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>

            <Modal open={favoriteModal}>
                <div className="vrufyerv">
                    <Box sx={style}>
                        <h3 className="type-of-list-fav">
                            {message}
                            <ClearIcon onClick={handleCloseFavoriteModal} style={{ cursor: "pointer" }} />
                        </h3>
                        <div className="type-of-list-fav-body">
                            <div className="de_hr">
                                <div className="de_btn_cont">
                                    <Button className="de_cancel" onClick={handleCloseFavoriteModal}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="de_next"
                                        onClick={() => handleMultipleFavorites()}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>

            {/* Add to Favorites List Modal */}
            <Modal open={addFavouriteModal}>
                <div className="vrufyerv">
                    <Box sx={style}>
                        <h3 className="type-of-list-fav">
                            Add to Favorites List
                            <ClearIcon onClick={handleCloseAddFavouriteModal} style={{ cursor: "pointer" }} />
                        </h3>
                        <div className="type-of-list-fav-body">
                            <div className="input-list-fav-create">
                                <label htmlFor="">New List Name</label>
                                <input type="text" onChange={(e) => setListName(e.target.value)} value={listName} />
                            </div>
                            <div className="de_hr">
                                <div className="de_btn_cont">
                                    <Button className="de_cancel" onClick={handleCloseAddFavouriteModal}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="de_next"
                                        onClick={() => {
                                            const isOrganization = selectedOuterRows.every(row => row.category === "organization");
                                            const isProspects = selectedOuterRows.every(row => row.category === "prospects");

                                            if (isOrganization) {
                                                saveOrgFavList();
                                            } else if (isProspects) {
                                                savePeopleFavList();
                                            } else {
                                                toast.error("Selected rows must be either all Organizations or all Prospects.");
                                            }
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Submit
                                    </Button>
                                    {/* <Button
                                        className="de_next"
                                        onClick={saveOrgFavList}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Submit
                                    </Button> */}
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>
        </>
    );
};
export default DataEnrichFavModal